const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};

export default trigger;



// WEBPACK FOOTER //
// ./src/common/directives/trigger.js